import { Field, Input, Label, Select } from '../Field';
import { addDays, format, parse } from 'date-fns';
import RadioGroup from '../RadioGroup';
import { useState, useEffect } from 'react';
import { fetchSlots } from '../../providers/slots';

function Fields({ clinic, coupon, fields, setFieldValue, setValid, t }) {
    const [slots, setSlots] = useState([]);
    const [hasVideo, setHasVideo] = useState(false);
    const [otherPatient, setOtherPatient] = useState(false);
    const [specialties, setSpecialties] = useState([]);

    useEffect(() => {
        const specialty = clinic?.specialties.find(({ id }) => id == fields.specialty_id);
        setHasVideo(specialty?.video == true);
    }, [fields.specialty_id]);

    useEffect(() => {
        if (!otherPatient) {
            setFieldValue('name', '');
        }
    }, [otherPatient]);

    useEffect(() => {
        if (!hasVideo) {
            setFieldValue('video', false);
        }
    }, [hasVideo]);

    useEffect(() => {
        if (fields.time) {
            if (!slots.find(({ start }) => fields.time == format(new Date(start), 'HH:mm'))) {
                setFieldValue('time', '');
            }
        }
    }, [slots]);

    useEffect(() => {
        const { professional_id, date } = fields;
        if (professional_id && date) {
            const fromDate = parse(`${date} 00:00`, 'yyyy-MM-dd HH:mm', new Date());
            const from = fromDate.toISOString();
            const to = addDays(fromDate, 1).toISOString();
            fetchSlots({ professional_id, from, to }).then(setSlots);
        } else {
            setSlots([]);
        }
    }, [fields.professional_id, fields.date]);

    useEffect(() => {
        if (clinic && fields.professional_id) {
            const professional = clinic.professionals.find(({ id }) => id == fields.professional_id);
            setSpecialties(professional?.specialties);
        } else {
            setSpecialties([]);
        }
    }, [clinic, fields.professional_id]);

    useEffect(() => {
        setValid(fields.specialty_id && fields.professional_id && fields.date && fields.time && (!otherPatient || fields.name.trim()));
    }, [fields, otherPatient]);

    const changeHandler = (e) => {
        const { name, value } = e.target;
        setFieldValue(name, value);
    };

    return (
        <div className="space-y-4">
            <div className="space-y-2">
                <Field>
                    <Label>{t('professional')}</Label>
                    <Select name="professional_id" options={clinic.professionals} value={fields.professional_id} onChange={changeHandler} />
                </Field>

                <Field>
                    <Label>{t('specialty')}</Label>
                    <Select name="specialty_id" options={specialties} value={fields.specialty_id} onChange={changeHandler} disabled={!fields.professional_id} />
                </Field>

                {fields.specialty_id && (
                    <Field>
                        <Label>{t('format.label')}</Label>
                        <RadioGroup
                            value={fields.video}
                            onChange={(value) => {
                                setFieldValue('video', value);
                            }}
                            options={[
                                {
                                    value: false,
                                    label: t('format.in-person'),
                                },
                                {
                                    value: true,
                                    label: t('format.video'),
                                    disabled: !hasVideo,
                                },
                            ]}
                        ></RadioGroup>
                    </Field>
                )}

                <Field>
                    <Label>
                        <span>{t('date')}</span>
                        <Input type="date" name="date" value={fields.date} onChange={changeHandler} />
                    </Label>
                </Field>

                <Field>
                    <Label>
                        <span>{t('time')}</span>
                    </Label>
                    <input type="hidden" name="time" value={fields.time} readOnly />
                    <div className="flex flex-wrap gap-2">
                        {slots.length ? (
                            slots.map(({ start, isAvailable }) => {
                                const time = format(new Date(start), 'HH:mm');
                                const active = time == fields.time;
                                return (
                                    <button
                                        key={time}
                                        type="button"
                                        disabled={!isAvailable}
                                        className={`${
                                            active ? 'cursor-default border-blue-400 bg-blue-100 text-primary' : 'border-blue-100 bg-blue-50 text-blue-600'
                                        } rounded border px-3 py-2 disabled:border-gray-200 disabled:bg-gray-100 disabled:text-gray-400`}
                                        onClick={() => {
                                            setFieldValue('time', time);
                                        }}
                                    >
                                        {time}
                                    </button>
                                );
                            })
                        ) : (
                            <span className="rounded border border-gray-200 bg-gray-100 px-3 py-2 text-gray-400">{t('no-slots')}</span>
                        )}
                    </div>
                </Field>

                <Field>
                    <Label>{t('recipient.label')}</Label>
                    <RadioGroup
                        value={otherPatient}
                        onChange={setOtherPatient}
                        options={[
                            {
                                value: false,
                                label: t('recipient.myself'),
                            },
                            {
                                value: true,
                                label: t('recipient.someone-else'),
                            },
                        ]}
                    ></RadioGroup>
                </Field>

                {otherPatient && (
                    <Field>
                        <Label>
                            <span>{t('recipient.patient-name')}</span>
                            <Input
                                type="text"
                                name="name"
                                value={fields.name}
                                onChange={(event) => {
                                    setFieldValue('name', event.target.value);
                                }}
                            />
                        </Label>
                    </Field>
                )}
            </div>
        </div>
    );
}

export default Fields;
